import { CANONICAL_ORIGIN } from "./routePolicy";

export const SITE_METADATA = {
  title: "Afi - Full Stack Developer Portfolio",
  description:
    "Portfolio of Afi, a passionate Full Stack Developer crafting modern web experiences with React, TypeScript, and cutting-edge technologies.",
  url: CANONICAL_ORIGIN,
  image: "/assets/images/logo.png",
  twitterHandle: "@afifolio",
} as const;
